import { render, staticRenderFns } from "./ColumnGoods.vue?vue&type=template&id=aba4017c&scoped=true&"
import script from "./ColumnGoods.vue?vue&type=script&lang=js&"
export * from "./ColumnGoods.vue?vue&type=script&lang=js&"
import style0 from "./ColumnGoods.vue?vue&type=style&index=0&id=aba4017c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba4017c",
  null
  
)

export default component.exports